export default __webpack_public_path__ + "static/media/undraw_video_upload_3d4u.8c0be043.svg";